module.exports = __webpack_public_path__ + "img/ÖppelEssen.6a50f94d.svg";